<template>
    <!-- 活动助力页 -->
    <div class="activity-boost-page">
        <!-- 登录组件 -->
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityUrl="activityUrl"></login-in>
        <drop-load :on-refresh="onPageShow">
            <div class="main-body">
                <img class="bg-img"
                    :src="invitationPicUrl" />
                <div class="main-area">
                    <div class="content">{{ content }}</div>
                    <!-- 按钮 -->
                    <div class="btn-group">
                        <!-- 未登录，我来助力按钮，点击引导跳转小程序登录 -->
                        <div v-if="isShowBoostBtn && helpedProgress==='1'"
                            class="complex-style-btn">
                            <div class="btn-text">我来助力</div>
                            <div class="blur-layer3-div">
                                <div class="blur-layer3"></div>
                            </div>
                            <div class="blur-layer2"></div>
                            <div class="blur-layer"></div>
                            <div class="orange-btn"></div>
                            <!-- 微信打开H5时跳转 -->
                            <div v-if="!miniprogramFlag && loginType == 'wechat'"
                                class="member-login-btn">
                                <div class="wxOpenLaunchWeapp">
                                    <wx-open-launch-weapp id="launch-btn"
                                        :username="hiHonorWxAppId"
                                        :env-version="envVersion"
                                        :path="`pages/tabBar/index/index.html?activityUrl=${encodeURIComponent(activityUrl)}`">
                                        <script type="text/wxtag-template">
                                            <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                                    </script>
                                    </wx-open-launch-weapp>
                                </div>
                            </div>
                        </div>
                        <!-- 已登录，我来助力按钮，点击去助力 -->
                        <div v-if="isShowBoostBtn && helpedProgress!=='1'"
                            class="complex-style-btn"
                            @click="handleJump('addShopper')">
                            <div class="btn-text">我来助力</div>
                            <div class="blur-layer3-div">
                                <div class="blur-layer3"></div>
                            </div>
                            <div class="blur-layer2"></div>
                            <div class="blur-layer"></div>
                            <div class="orange-btn"></div>
                        </div>
                        <div v-if="isShowJoinBtn"
                            :class="{ 'complex-style-btn': true, 'short-btn': isShowLuckyDrawBtn }"
                            @click="handleJump('activityManagement')">
                            <div class="btn-text">我也要参加</div>
                            <div class="blur-layer3-div">
                                <div class="blur-layer3"></div>
                            </div>
                            <div class="blur-layer2"></div>
                            <div class="blur-layer"></div>
                            <div class="orange-btn"></div>
                        </div>
                        <!-- 去抽奖/去查看按钮 -->
                        <div v-if="isShowLuckyDrawBtn"
                            class="complex-style-btn short-btn"
                            @click="handleJump('luckyDraw')">
                            <div class="btn-text rose-red-text">{{ luckyDrawBtnContent }}</div>
                            <div class="blur-layer3-div">
                                <div class="blur-layer3 rose-red-layer3"></div>
                            </div>
                            <div class="blur-layer2"></div>
                            <div class="blur-layer rose-red-layer"></div>
                            <div class="orange-btn rose-red-btn"></div>
                        </div>
                    </div>
                </div>
            </div>
        </drop-load>
    </div>
</template>

<script>
import LoginIn from '../dynamicAttr/modal/login-in.vue';
import { LoginType } from '../../../../commons/commonVariables';
import utils, { updateUserInfoCache } from '../../../../utils/comUtils';
import { EnvMark } from '../../runtime/lucky-draw/common/global-variable';
import { getEnvMark, getWxSDKAuth, checkActivityStatus } from '../../runtime/common-methods/utils';
import { config } from '../../../../api/config';
import wx from 'weixin-js-sdk';
import { Dialog } from 'vant';
import DropLoad from '../../../../components/common/drop-load.vue';
import { config as configEnv } from '../../../../commons/config.js';

// 添加和移除事件的监听方法
const EVENT = {
  // 添加
  addHandler(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      // 兼容ie
      element.attachEvent('on' + type, handler);
    } else {
      element['on' + type] = handler;
    }
  },

  // 移除
  removeHandler(element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false);
    } else if (element.detachEvent) {
      // 兼容ie
      element.detachEvent('on' + type, handler);
    } else {
      element['on' + type] = null;
    }
  },
};
export default {
  components: {
    LoginIn,
    DropLoad,
  },
  data() {
    return {
      loginType: LoginType.Wechat, // 只有微信登录一种场景
      isLoginFlag: '', // 是否登录
      activityUrl: '', // 页面当前地址
      shareId: '', // 分享id
      qyWeChatQrId: '', // 聚合码id
      invitationPicUrl: '', // 助力背景url
      activityCode: '', // 活动编码
      inviteeActivityCode: '', // 大转盘活动编码
      taskCode: '', // 任务编码
      helpedProgress: '', // 助力进度
      isShowBoostBtn: false,
      isShowJoinBtn: false,
      isShowLuckyDrawBtn: false,
      content: '',
      luckyDrawBtnContent: '',
      inviterUnionid: '', //邀请者的unionid
      hiHonorWxAppId: config.otherConfig.hiHonorWxAppId,
      envVersion: configEnv.env === 'pro' ? 'release' : 'trial',
      miniprogramFlag: false,
    };
  },
  async created() {
    try {
      const env = getEnvMark();
      this.miniProgramFlag = env === EnvMark.wechatMp || env === EnvMark.alipayMp;
      // 微信H5场景，需要获取开放标签的权限
      if (env === EnvMark.wechatH5 && this.isNeedWxAuth) {
        getWxSDKAuth();
      }
    } catch (err) {
      // 若上述方法出错，则使用备用方法
      this.miniProgramFlag = window.__wxjs_environment === 'miniprogram';
    }
    sessionStorage.setItem('loginType', 'wechat');
    try {
      document.title = '邀请好友助力';
      const routeQuery = this.$route.query || {};
      console.log('活动助力页 query===>', routeQuery);
      if (routeQuery && routeQuery.shareId) {
        // 分享id
        this.shareId = routeQuery.shareId || '';
        console.log('活动助力页-分享id===>', this.shareId);
        this.isLoginFlag = this.checkLogin();
        await this.onPageShow();
        this.activityUrl = `${window.location.origin}/hd/activityBoostPage?activityCode=${this.activityCode}&shareId=${this.shareId}`;
        // 排除本地调试 以及 大转盘/活动H5返回助力页 的场景
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
        if (this.isLoginFlag && !window.location.host.includes('localhost') && !userInfo.userToken) {
          const loginResult = await this.wxLogin();
          if (loginResult) {
            // 登录成功
            await this.onPageShow();
            // 进入页面埋点
            this.EventTrackingAndReportingOfGoActivityPage();
            // 请求保存用户关系接口：0未助力、 6助力失败、 7助力失败 
            if (['0','6','7'].includes(this.helpedProgress)) {
              this.saveUserRelationship(this.shareId, this.taskCode, this.activityCode);
            }
          }
        }
        this.handleNumberOfScans();
      } else {
        console.error('shareId不能为空');
        Dialog.alert({
          title: '提示',
          message: '活动异常，请重试',
        });
        this.setPageConfigByProgress('2');
      }
    } catch (error) {
      Dialog.alert({
        title: '提示',
        message: '活动过于火爆，请稍后再试',
      });
      this.setPageConfigByProgress('2');
    }
  },
  mounted() {
    this.getWxConfig();
    // 刷新页面
    EVENT.addHandler(document, 'visibilitychange', () => {
      if (document.visibilityState == 'visible' && this.isLoginFlag) {
        this.onPageShow();
      }
    });
  },
  destroyed() {
    // 组件销毁时，需要移除页面事件监听
    EVENT.removeHandler(document, 'visibilitychange', () => {});
  },
  methods: {
    /**
     * 点击按钮，跳转到其他页面
     */
    handleJump(pageName) {
      if (pageName === 'addShopper') {
        checkActivityStatus('', '', this.shareId, this).then((res) => {
          if (res) {
            // 我来助力埋码
            this.EventTrackingAndReportingOfHelp();
            // 跳转小程序聚合码页
            wx.miniProgram.navigateTo({
              url: `/subpackages/activity/pages/nearShoppers/add-shopper?endId=magicActivity&taskType=invitationTask&aggregationCodeId=${
                this.qyWeChatQrId
              }&activityUrl=${encodeURIComponent(this.activityUrl)}`,
            });
          }
        });
      } else if (pageName === 'activityManagement') {
        // 我也参加活动埋码
        this.EventTrackingAndReportingOfGoTo();
        // 跳转H5活动页
        let path = `/hdmain?activityCode=${this.activityCode}`;
        this.$router.push({ path });
      } else if (pageName === 'luckyDraw') {
        // 我来抽奖埋码
        this.EventTrackingAndReportingOfGetPrize();
        // 跳转H5大转盘页
        let path = `/hdmain?activityCode=${this.inviteeActivityCode}`;
        this.$router.push({ path });
      }
    },
    /**
     * 页面展示时，请求助力页信息
     */
    onPageShow() {
      // 请求助力页信息
      return new Promise((resolve, reject) => {
        this.$api.post({
          sc: 'mobileMarketingH5',
          url: `activityTask/queryInviterDetail/${this.shareId}`,
          success: (res) => {
            if (res && res.result) {
              this.activityCode = res.result.activityCode || ''; // 活动编码
              this.taskCode = res.result.taskCode || ''; // 邀请任务编码
              this.qyWeChatQrId = res.result.qywechatQrId || ''; //聚合码id
              // 助力页背景图
              this.invitationPicUrl =
                this.$utils.getImageUrl(res.result.invitationPicUrl) || 'https://hshop.honorfile.com/pimages//pages/cdnImages/41476889057718867414.jpg'; // 默认背景图地址
              this.helpedProgress = res.result.helpedProgress || ''; // 助力进度
              this.inviteeActivityCode = res.result.inviteeActivityCode || ''; // 大转盘活动编码
              this.inviterUnionid = res.result.inviterUnionid; // 邀请者的uid
              //根据登录环境和登录状态，判断是否展示页面文字内容和按钮（本地展示，H5展示，小程序未登录不展示，登录则展示）
              const curEnv = getEnvMark();
              console.log('活动助力页-当前环境 curEnv===>', curEnv);
              const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
              const shouldDisplayContentAndBtn =
                curEnv === EnvMark.wechatH5 || (curEnv === EnvMark.wechatMp && userInfo.userToken) || window.location.host.includes('localhost');
              shouldDisplayContentAndBtn && this.setPageConfigByProgress(this.helpedProgress);
              resolve(true);
            } else {
              reject(false);
            }
          },
          failure: (err) => {
            reject(false);
          },
        });
      });
    },
    /**
     * 根据助力进度设置不同的页面配置
     */
    setPageConfigByProgress(helpedProgress) {
      switch (helpedProgress) {
        case '0':
          // 被邀请人未助力
          this.content = '添加导购企微即可助力成功\n您可享新人礼福利';
          this.isShowBoostBtn = true;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '1':
          // 未登录
          this.content = '添加导购企微即可助力成功\n您可享新人礼福利';
          this.isShowBoostBtn = true;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '2':
          // 分享id不存在
          Dialog.alert({
            title: '提示',
            message: '活动异常，请重试',
          });
          this.content = '活动异常，请重试';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '3':
        // 活动已过期，有抽奖机会
        case '4':
          // 任务已过期，有抽奖机会
          this.content = '活动已结束！';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = true;
          this.luckyDrawBtnContent = '去查看';
          break;
        case '5':
          // 邀请人为自己助力
          this.content = '不能为自己助力哦\n快去邀请好友为你助力吧';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '6':
          // 被邀请人已经添加过企微好友
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
          const nickName = userInfo.nickName ? `${userInfo.nickName}，` : '';
          this.content = `${nickName}您已经添加过导购企微啦\n无法为好友助力哦\n来邀请您的好友一起参加吧`;
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = false;
          break;
        case '7':
          // 被邀请人已经助力过其他好友
          this.content = '您已经为其他好友助力过啦\n不能重复助力\n来一起邀请您的好友参与吧';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = false;
          break;
        case '8':
          // 活动已暂停，有抽奖机会
          this.content = '活动已暂停！';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = true;
          this.luckyDrawBtnContent = '去查看';
          break;
        case '9':
          // 助力成功，删除好友关系，抽奖次数被回收
          this.content = '您已删除企微好友，抽奖机会已失效\n邀请新好友，再赢抽奖机会吧';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = false;
          break;
        case '10':
          // 助力成功，有抽奖机会
          this.content = '助力成功！赠送您1次抽奖机会\n参与活动邀请好友加企微，获得抽奖机会';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = true;
          this.luckyDrawBtnContent = '去抽奖';
          break;
        case '11':
          // 助力成功，无抽奖机会
          this.content = '助力成功\n参与活动邀请好友加企微，获得抽奖机会';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = false;
          break;
        case '12':
        // 活动已过期，无抽奖机会
        case '13':
          // 任务已过期，无抽奖机会
          this.content = '活动已结束！';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '14':
          // 活动已暂停，无抽奖机会
          this.content = '活动已暂停！';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = false;
          this.isShowLuckyDrawBtn = false;
          break;
        case '15':
          // 助力成功，无抽奖机会，删除好友关系
          this.content = '您已删除企微好友，助力已失效\n邀请新好友，再赢抽奖机会吧';
          this.isShowBoostBtn = false;
          this.isShowJoinBtn = true;
          this.isShowLuckyDrawBtn = false;
          break;
      }
    },
    /**
     * 保存用户关系
     */
    saveUserRelationship(shareId, taskCode, activityCode) {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
      const params = {
        shareId,
        taskCode,
        activityCode,
        userHeadPortraitUrl: userInfo.avatarUrl || '',
        nickName: userInfo.nickName || '',
      };
      // 标记 nickName 为明文隐私字段，交由 privacySave 做脱敏/加密处理
      const privacyKeys = {
        nickName: "$PrivacyPlain$"
      };
      // 隐私字段元数据：字段名、数据类型、标签，用于上报隐私合规系统
      const privacyKeyList = [
        {
          nickName: "nickName",
          typeText: "NAME",
          labelText: "nick_name"
        }
      ];
      // 对 params 中的隐私字段做预处理后再发起接口请求
      this.$utils.privacySave(privacyKeys, privacyKeyList, params);
      this.$api.post({
        sc: 'mobileMarketingH5',
        url: `/activityTask/saveUserRelationship`,
        params,
        success: (res) => {
          if (!res || res.code !== 200) {
            console.log('保存用户关系失败=====>:', res);
          }
        },
        failure: (err) => {
          console.log('保存用户关系失败=====>:', err);
        },
      });
    },
    /**
     * 校验是否已登录
     */
    checkLogin() {
      // 本地默认登录
      if (window.location.host.includes('localhost')) {
        sessionStorage.setItem('isLoginFlag', 'true');
        const userObj = {
          openId: config.userInfo.userInfo && config.userInfo.userInfo.openId,
          unionid: config.userInfo.userInfo && config.userInfo.userInfo.unionid,
          accessToken: config.userInfo.accessToken,
          userToken: config.userInfo.userToken,
          memberCenterId: config.userInfo.userInfo && config.userInfo.userInfo.memberCenterId,
          member: config.userInfo.userInfo && config.userInfo.userInfo.member,
        };
        updateUserInfoCache(userObj, LoginType.Wechat);
        return true;
      } else {
        // 通过query.isLoginFlag判断是否登录成功
        const flag = (this.$route.query && this.$route.query.isLoginFlag) || false;
        sessionStorage.setItem('isLoginFlag', flag);
        return flag;
      }
    },
    /**
     * 微信登录，返回登录结果。
     * 登录成功：设置userInfo缓存，已及isLoginFlag字段为TRUE。
     * 登录失败：清空userInfo缓存，已及isLoginFlag字段为FALSE。
     */
    wxLogin() {
      const loginCode = (this.$route.query && this.$route.query.loginCode) || '';
      if (loginCode) {
        const sc = this.$memberMixSwitch ? 'mobileWxMix' : 'mobileWx';
        const url = this.$memberMixSwitch ? 'quicklogin' : `getsession?code=${loginCode}`;
        const headers = this.$memberMixSwitch
          ? {
              'content-type': 'application/json',
              accept: 'application/json;charset=UTF-8',
            }
          : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
        const params = this.$memberMixSwitch ? { code: loginCode } : '';
        return new Promise((resolve) => {
          this.$api.post({
            noLoading: true,
            sc: sc,
            url: url,
            params: params,
            headers: headers,
            success: (r) => {
              const userObj = {
                openId: '',
                unionid: '',
                accessToken: '',
                userToken: '',
                memberCenterId: '',
                member: false,
                nickName: '',
                avatarUrl: '',
              };
              const isSuccess = this.$memberMixSwitch ? r.code === '666666' : r.data;
              if (isSuccess) {
                userObj.unionid = r.data.unionid || '';
                userObj.nickName = r.data.nickName || '';
                userObj.avatarUrl = r.data.avatarUrl || 'https://hshop.honorfile.com/pimages//pages/cdnImages/79067167008616176097.png';
                userObj.openId = r.data.openid || '';
                userObj.accessToken = r.data.accessToken || '';
                userObj.userToken = r.data.usertoken || '';
                userObj.memberCenterId = r.data.memberId || '';
                userObj.member = userObj.memberCenterId ? true : false;
              }
              // 以返回的result内的参数，作为是否登入成功的标识
              const isLoginFlag = r.result === 1 && userObj.accessToken && userObj.userToken ? true : false;
              const isLoginFlagMix = r.code === '666666' && userObj.accessToken && userObj.userToken ? true : false;
              // 缓存到session
              const flag = this.$memberMixSwitch ? isLoginFlagMix : isLoginFlag;
              this.isLoginFlag = flag;
              sessionStorage.setItem('isLoginFlag', flag);
              updateUserInfoCache(userObj, LoginType.Wechat);
              this.$memberMixSwitch ? resolve(isLoginFlagMix) : resolve(isLoginFlag);
            },
            failure: () => {
              sessionStorage.setItem('isLoginFlag', 'false');
              updateUserInfoCache(null, LoginType.Wechat);
              resolve(false);
            },
          });
        });
      } else {
        // 未传wxLoginCode，设置isLoginFlag为FALSE，表示未登录
        sessionStorage.setItem('isLoginFlag', 'false');
        updateUserInfoCache(null, LoginType.Wechat);
        return Promise.resolve(false);
      }
    },
    EventTrackingAndReportingOfGoActivityPage() {
      // mid、unionid、活动编码、任务编码、邀请人mid、邀请人unionid
      const params = {
        actionCode: 400070010,
        actionName: '进入活动页',
        content: {
          title: '进入活动页',
          channel: '微信',
          taskCode: this.taskCode,
          activityCode: this.activityCode,
          inviterUnionid: this.inviterUnionid,
        },
      };
      utils.handleBatchReport(this, params);
    },
    EventTrackingAndReportingOfHelp() {
      // mid、unionid、活动编码、任务编码、邀请人mid、邀请人unionid
      const params = {
        actionCode: 400070011,
        actionName: '点击我来助力',
        content: {
          title: '点击我来助力',
          channel: '微信',
          taskCode: this.taskCode,
          activityCode: this.activityCode,
          inviterUnionid: this.inviterUnionid,
        },
      };
      utils.handleBatchReport(this, params);
    },
    EventTrackingAndReportingOfGetPrize() {
      // mid、unionid、活动编码、任务编码、邀请人mid、邀请人unionid
      const params = {
        actionCode: 400070012,
        actionName: '点击去抽奖',
        content: {
          title: '点击去抽奖',
          channel: '微信',
          taskCode: this.taskCode,
          activityCode: this.activityCode,
          inviteeActivityCode: this.inviteeActivityCode,
          inviterUnionid: this.inviterUnionid,
        },
      };
      utils.handleBatchReport(this, params);
    },
    EventTrackingAndReportingOfGoTo() {
      // mid、unionid、活动编码、任务编码、邀请人mid、邀请人unionid
      const params = {
        actionCode: 400070013,
        actionName: '点击我也参加活动',
        content: {
          title: '点击我也参加活动',
          channel: '微信',
          taskCode: this.taskCode,
          activityCode: this.activityCode,
          inviterUnionid: this.inviterUnionid,
        },
      };
      utils.handleBatchReport(this, params);
    },
    // 统计扫码次数
    handleNumberOfScans() {
      const params = {
        activityCode: this.activityCode || '',
        channel: 'magicActivity',
      };
      console.log('记录扫码进入活力助力页次数====params', params);
      if (params.activityCode && params.activityCode.substr(0, 2) === 'HD') {
        this.$api.post({
          sc: 'mobileMarketing',
          url: 'miniMemberAndCommunityStatistics/countJoinMemberScanNum',
          params,
        });
      }
    },
    getWxConfig() {
      const jsApiList = ['hideAllNonBaseMenuItem'];
      getWxSDKAuth('', jsApiList).then((res) => {
        // 获取授权成功
        if (res) {
          console.log('获取微信授权成功');
          wx.ready(function () {
            // 隐藏所有非基础按钮接口
            wx.hideAllNonBaseMenuItem();
          });
        } else {
          console.log('获取微信授权失败');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-boost-page {
  .main-body {
    width: 100vw;
    height: 100vh;
    position: relative;

    .bg-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center; /* 关键：将图片顶部对齐到容器顶部，水平居中 */
      display: block;
      z-index: -1;
    }

    .main-area {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      top: 53vh;
      text-align: center;

      .content {
        width: 400px;
        color: #000;
        font-size: 16px;
        margin-bottom: 20px;
        white-space: pre-wrap;
      }

      .btn-group {
        display: flex;

        .complex-style-btn {
          position: relative;
          width: 200px;
          height: 46px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          &:last-child {
            margin-right: 0;
          }

          .member-login-btn {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
            z-index:1010;
          }

          .btn-text {
            width: 100%;
            opacity: 1;
            text-align: center;
            font-size: 18.87px;
            font-weight: bold;
            color: #ffffff;
            z-index: 1000;
            text-shadow: 0px 0px 2px #e13100;
          }

          .blur-layer {
            z-index: 999;
            left: 4px;
            top: 4px;
            position: absolute;
            width: calc(100% - 8px);
            height: calc(100% - 8px);
            border-radius: 25.48px;
            opacity: 1;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 130, 0, 0) 100%);
            filter: blur(2px);
          }

          .blur-layer2 {
            position: absolute;
            left: 20px;
            top: 18px;
            width: 160px;
            height: 38px;
            border-radius: 25.48px;
            mix-blend-mode: multiply;
            opacity: 0.5;
            background: #9ddcff;
            filter: blur(10px);
          }

          .blur-layer3-div {
            position: absolute;
            z-index: 1001;
            width: 200px;
            height: 46px;
            overflow: hidden;

            .blur-layer3 {
              z-index: 1001;
              position: absolute;
              left: 54px;
              top: 41px;
              width: 92px;
              height: 15px;
              opacity: 1;
              border-radius: 50%;
              background: #ffc041;
              filter: blur(10px);
            }
          }

          .orange-btn {
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 28.31px;
            opacity: 1;
            border: 2px solid #ffffff;
            background: linear-gradient(90deg, #ff1700 0%, #ff8200 100%);
          }
        }

        .short-btn {
          width: 140px;

          .rose-red-text {
            text-shadow: 0px 0px 2px #fd2d45;
          }

          .blur-layer2 {
            left: 18px;
            width: 104px;
          }

          .blur-layer3-div {
            width: 140px;

            .blur-layer3 {
              left: 24px;
            }

            .rose-red-layer3 {
              background: #ffafe2;
            }
          }

          .rose-red-layer {
            background: linear-gradient(180deg, rgba(246, 149, 255, 0.5) 0%, rgba(186, 125, 255, 0) 100%);
          }

          .rose-red-btn {
            background: linear-gradient(90deg, #fd2c42 0%, #fd48af 100%);
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activity-boost/activity-boost-page.vue